module.exports = "data:image/png;base64,UklGRmQAAABXRUJQVlA4WAoAAAAQAAAACgAACgAAQUxQSCUAAAABHyAgIbLVeDPciIg4gaI2UqBZzi8ikIB/fUiI6H8WK4afmOYAAFZQOCAYAAAAMAEAnQEqCwALAAIANCWkAANwAP77lAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/DelegatePin_Connected.png
// module id = 30
// module chunks = 0